import React, { PureComponent } from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import moment from "moment";

import { getListingImage } from "../../../constants/util";

class DashboardBookingRenterSmall extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    let { booking } = this.props;
    let startDate = moment(booking.startDate);
    let endDate = moment(booking.endDate);
    let numDays = Math.ceil(endDate.diff(startDate, "d", true));
    return (
      <Link to={`/dashboard/bookings/${booking._id}`}>
        <div className="dashboard-booking-small">
          <div className="row">
            <div className="col">
              <h6>
                {startDate.format("M/D")} - {endDate.format("M/D")} ({numDays}{" "}
                nights)
              </h6>
            </div>
          </div>
          <div className="row d-flex">
            {booking.listingId.photos.length > 0 && (
              <div className="col-4 pr-0 image-container">
                <div
                  style={{
                    backgroundImage: `url(${getListingImage(
                      booking.listingId
                    )})`,
                  }}
                />
              </div>
            )}
            <div className="col d-block ">
              <div className="font-weight-bold ">
                {booking.listingId.listingName}
              </div>
              <div className="  ">
                {booking.listingId.address.city},{" "}
                {booking.listingId.address.state}
              </div>
            </div>
          </div>
        </div>
      </Link>
    );
  }
}

export default withRouter(DashboardBookingRenterSmall);
